import { config, handleResponse } from '../../_helpers';

export const sqDocumentServices = {
    createSqDocument,
    updateSqDocument,
    deleteSqDocument,
    getSqDocumentBySqDocNum,
    ExpiredDocuments,
};

function createSqDocument(values) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotationDocuments/MultipleInsertDocsWAreas`, requestOptions).then(handleResponse);
}
function updateSqDocument(values) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(values),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotationDocuments/UpdateManyDocsWAreas/${values.sqdocNum}`, requestOptions).then(handleResponse);
}
function deleteSqDocument(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotationDocuments/deleteDocsWArea/${id}`, requestOptions).then(handleResponse);
}
function getSqDocumentBySqDocNum(sQDocNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/SalesQuotationDocuments/${sQDocNum}`, requestOptions).then(handleResponse);
}
function ExpiredDocuments(values) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(values),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotationDocuments/ExpiredDocuments`, requestOptions).then(handleResponse);
}